import "core-js/modules/es.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util from '@/libs/util';
export default {
  name: 'uploadpic',
  props: {
    fileList: Array
  },
  data: function data() {
    return {
      uploadPath: process.env.VUE_APP_API + '/paperQuestion/setPic',
      uploadHeader: {
        token: util.cookies.get('token')
      },
      picDialogVisible: false,
      dialogImageUrl: ''
    };
  },
  methods: {
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.fileList[0] = {
        name: file.name,
        url: res.data
      };
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (this.fileList.length === 1) {
        this.$message.error('只能上传1张图片!');
        return false;
      }

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG、PNG 格式!');
      }

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }

      return isJPG && isLt2M;
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm('确定移除' + file.name + '？');
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = [];
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.picDialogVisible = true;
    }
  }
};